<template>
    <md-field :class="{'md-invalid': !!errors}" class="phone-field" v-if="!newVersion">
        <label v-if="showLabel">
            {{ label }}
        </label>
        <!-- <span class="md-prefix"> -->
        <md-menu md-direction="bottom-start" class="shrink-0">
            <md-button md-menu-trigger>
                {{ ((selectedCountry && countriesMap[selectedCountry]) ? countriesMap[selectedCountry].callingCode : '') }}
                <custom-icon name="arrow_drop_down" />
            </md-button>

            <md-menu-content>
                <md-menu-item v-for="country in countries" :key="country.idPays" @click="selectedCountry=country.idPays" :dusk="'phone_country_' + country.isoCode">
                    {{ country.isoCode + ' (' + country.callingCode + ')' }}
                </md-menu-item>
            </md-menu-content>
        </md-menu>
        <!-- </span> -->
        <md-input :placeholder="showLabel ? null : label" :name="name" v-model="useValue" @blur="wasFocused = true" :disabled="disabled" :required="required" type="tel" autocomplete="tel" />
        <span class="md-error">{{ errors ? errors[0] : '' }}</span>
    </md-field>
    <div class="PhoneFieldComponent" v-else>
        <div class="flex">
            <md-menu md-direction="bottom-start" class="shrink-0 z-10 inline-flex items-center px-0 text-sm font-medium text-center bg-white border border-gray-200 text-gray-900 border-e-0 rounded-s-md hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-300">
                <md-button md-menu-trigger class="!py-0 !min-w-8 !px-1 nv-button text-sm font-normal h-auto">
                    {{ ((selectedCountry && countriesMap[selectedCountry]) ? countriesMap[selectedCountry].callingCode : '') }}
                    <custom-icon name="arrow_drop_down" />
                </md-button>

                <!-- Above the z-10 trigger it opens over (vue-material gives menus z-index 9) -->
                <md-menu-content style="z-index: 120">
                    <md-menu-item v-for="country in countries" :key="country.idPays" @click="selectedCountry=country.idPays" :dusk="'phone_country_' + country.isoCode">
                        {{ country.isoCode + ' (' + country.callingCode + ')' }}
                    </md-menu-item>
                </md-menu-content>
            </md-menu>
            <div class="relative w-full">
                <!-- </span> -->
                <input :placeholder="showLabel ? null : label"
                          :name="name"
                          v-model="useValue"
                          @blur="wasFocused = true"
                          :disabled="disabled"
                          :required="required"
                          type="tel"
                          autocomplete="tel"
                          class="block bg-white border border-gray-200 text-gray-900 text-sm rounded-e-md focus:ring-blue-900 block w-full p-1.5 w-full z-20 placeholder:italic"
                          :class="{ 'border-red-500 focus:border-red-500 focus:ring-red-500': !!errors }"
                >
            </div>
        </div>
        <p class="mt-2 text-xs text-red-500" v-if="errors">{{ errors ? errors[0] : '' }}</p>
    </div>
</template>

<script>
import { parseNumber, formatNumber, AsYouType, isValidNumber } from 'libphonenumber-js';
import { parsePhoneNumber } from 'libphonenumber-js/max';

export default {
    props: {
        name: String,
        value: String,
        errors: Array,
        label: String,
        countryId: String,
        disabled: String,
        required: Boolean,
        showLabel: {
            type: Boolean,
            default: true,
        },
        mobileOnly: {
            type: Boolean,
            default: false,
        },
        newVersion: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            countries: [],
            countriesMap: {},
            theSelectedCountry: this.countryId,
            phoneInputValue: ''
        };
    },
    computed: {
        useValue: {
            get() {
                if (!this.phoneInputValue) {
                    if (this.value === null) {
                        this.phoneInputValue = '';
                    } else {
                        var parsedNumber = parseNumber(this.value);
                        if (parsedNumber.phone) {
                            this.phoneInputValue = parsedNumber.phone;
                        } else {
                            this.phoneInputValue = this.value;
                        }
                    }
                    this.processValue();
                }
                return this.phoneInputValue;
            },
            set(value) {
                this.phoneInputValue = value;
                this.processValue();
            }
        },
        selectedCountry: {
            get() {
                return this.theSelectedCountry;
            },
            set(country) {
                this.theSelectedCountry = country;
                this.processValue();
            }
        }
    },
    watch: {
        value(v) {
            if (v === '') {
                this.phoneInputValue = '';
            }
        }
    },
    mounted() {
        this.$root.getCountries().then(countries => {
            countries.forEach(country => {
                if (country.isoCode && country.callingCode) {
                    this.countries.push(country);
                    this.countriesMap[country.idPays] = country;
                }
            });
            this.processValue();
        });
    },
    methods: {
        processValue() {
            if (this.selectedCountry && this.countriesMap[this.selectedCountry]) {
                var parsedNumber = parseNumber(this.phoneInputValue, this.countriesMap[this.selectedCountry].isoCode);
                if (parsedNumber.country) {
                    var newCountry = Object.values(this.countries).filter(c => c.isoCode === parsedNumber.country);
                    if (newCountry.length == 1) {
                        newCountry = newCountry[0].idPays;
                        if (newCountry != this.selectedCountry) {
                            this.selectedCountry = newCountry;
                        }
                    }
                    var formattedNumber = formatNumber({country: parsedNumber.country, phone: parsedNumber.phone}, 'International');
                    if (isValidNumber(formattedNumber)) {
                        if (this.mobileOnly && parsePhoneNumber(parsedNumber.phone, parsedNumber.country).getType() !== 'MOBILE') {
                            this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                            this.$emit('input', this.phoneInputValue);
                        } else {
                            this.phoneInputValue = formattedNumber.substring(this.countriesMap[this.selectedCountry].callingCode.length).trim();
                            this.$emit('input', formattedNumber);
                            this.$emit('valid', formattedNumber);
                        }
                    } else {
                        this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                        this.$emit('input', this.phoneInputValue);
                    }
                } else {
                    this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                    this.$emit('input', this.phoneInputValue);
                }
            } else {
                this.phoneInputValue = this.phoneInputValue.replace(/ /g, '');
                this.$emit('input', this.phoneInputValue);
            }
        }
    }
};
</script>
<style lang="scss">
@import "~styles/_variables";
.PhoneFieldComponent {
    .nv-button:hover:before  {
        background-color: transparent !important;
    }
    .nv-button {
        .md-button-content {
            padding-top: 2px;
        }
    }
    input:focus,
    input:focus-visible {
        outline: none !important;
        box-shadow: none !important;
        border-color: $primary-color-dark !important;
    }
    input {
        color: $primary-color-dark;
    }
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/PhoneFieldComponent.vue